import React, { memo, useEffect, useState } from 'react';
import { useDebounce } from '~/modules/Helper/hooks/debounce.hook';
import Icons from '../Icons/Icons.component';
import * as S from './Menu.styled';

const MENU_SEARCH_DEBOUNCE_MS = 400;

const MENU_CLEAR_ICON = (
  <Icons.CloseCircleFilled aria-label="Limpar pesquisa do menu" />
);

function MenuPortalSearch({ onSearchTermChange, onClear }) {
  const [searchValue, setSearchValue] = useState('');
  const debouncedSearchValue = useDebounce(searchValue, MENU_SEARCH_DEBOUNCE_MS);

  useEffect(() => {
    const trimmed = debouncedSearchValue.trim();

    if (!trimmed) {
      onClear();
      return;
    }

    onSearchTermChange(trimmed);
  }, [debouncedSearchValue, onClear, onSearchTermChange]);

  function handleChange(event) {
    const { value } = event.target;
    setSearchValue(value);

    if (value === '') {
      onClear();
    }
  }

  return (
    <S.SearchField>
      <S.SearchLabel htmlFor="menu-portal-pesquisar">Pesquisar</S.SearchLabel>
      <S.SearchMenu
        id="menu-portal-pesquisar"
        placeholder="Digite para filtrar o menu"
        maxLength={50}
        value={searchValue}
        type="text"
        onChange={handleChange}
        allowClear={{ clearIcon: MENU_CLEAR_ICON }}
        aria-label="Pesquisar itens do menu"
      />
    </S.SearchField>
  );
}

export default memo(MenuPortalSearch);
